var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7,247.1c2.4-4,4.3-8.2,7.2-11.8c34.7-43.5,74.9-80.7,123.3-108.6C166.1,108.4,200.1,96,237,93.6 c33.9-2.3,66.3,4.4,97.4,17.7c44.5,19,82.6,47.5,116.5,81.7c14.1,14.2,26.9,29.6,39.9,44.8c7.4,8.6,7.1,15.7,0.1,24.7 c-35,44.3-75.6,82.3-124.7,110.6c-38.5,22.2-79.7,35.7-124.8,33.7c-31-1.4-60.2-9.7-88-23.4C95.1,354.7,48.5,312.2,8.6,261.7 c-2-2.6-3.2-5.8-4.8-8.8C3.7,251,3.7,249.1,3.7,247.1z M40.5,249.7c1.8,2.1,3,3.8,4.5,5.3c15,15.4,29.3,31.4,45.1,45.9 c30.5,27.8,64.5,50.5,104,64c23.7,8,47.9,11.5,72.8,8.7c32-3.5,61-15.4,88.3-31.7c35.5-21.3,65.9-48.7,93.4-79.3 c3.6-4,7-8.2,10.9-12.7c-9.5-10.2-18.3-20.3-27.7-29.9c-31.7-32.2-66.8-59.8-108.6-77.9c-20.8-9-42.5-15-65.4-16 c-34.9-1.6-67.1,8.1-97.7,23.9c-34.2,17.7-63.8,41.6-90.7,68.8C59.5,228.6,50.2,239.2,40.5,249.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.2,250.4c-0.4,54-44.4,97.5-97.9,96.9c-53.9-0.6-97-44.2-96.6-97.7c0.4-54,44.4-97.5,97.9-96.9 C304.5,153.4,347.6,197,347.2,250.4z M314.8,250.2c0.2-35.7-28.6-64.7-64.6-65.1c-35.6-0.4-65.3,29.2-65.2,65 c0.1,35.8,29.1,64.7,64.8,64.8C285.6,315,314.6,286.1,314.8,250.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.7b7a503c473dc7d39d801c34451b0f7f.svg";
export { ForwardRef as ReactComponent };